module.exports = __webpack_public_path__ + "static/media/Arctype.7fd2e50f.png";